import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOrderStatus } from './checkout-status.hooks';
import { usePageTitle } from 'hooks/usePageTitle.hooks';
import IncWaitPage from 'components/inc-wait-page/inc-wait-page.component';

const CheckoutStatus = () => {
  const { t } = useTranslation();
  useOrderStatus();
  const title = usePageTitle(t('head.title.processing'));

  return (
    <IncWaitPage helmetTitle={title}>
      <Typography>{t('checkout.statusPage.pleaseWait1')}</Typography>
      <Typography variant="body2">
        {t('checkout.statusPage.pleaseWait2')}
      </Typography>
    </IncWaitPage>
  );
};
export default CheckoutStatus;
